
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/real-time/personalization-api",
      function () {
        return require("private-next-pages/real-time/personalization-api.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/real-time/personalization-api"])
      });
    }
  